import api from '@/plugins/api';
import storage from '@/plugins/storage';
import * as types from './types';

export default {
  namespaced: true,

  // Synchronous initial state - no async here
  state: {
    configuration: [],
    configurationDataLoaded: false,
  },

  getters: {
    configuration: (state) => state.configuration,
    isConfigurationDataLoaded: (state) => state.configurationDataLoaded
  },

  mutations: {
    [types.SET_CONFIGURATION](state, data) {
      state.configuration = data;
      // Save to local storage as JSON string
      storage.local.setItem(types.CONFIGURATION, JSON.stringify(data));
    },
    [types.SET_CONFIGURATION_DATA_LOADED](state, val) {
      state.configurationDataLoaded = val
    },
  },

  actions: {
    // Load config from storage on app start or router guard
    async loadDynamicConfigurationDataFromStorage({ commit }) {
      try {
        const raw = await storage.local.getItem(types.CONFIGURATION);
        let data = [];
        if (raw) {
          data = JSON.parse(raw);
          if (!Array.isArray(data)) {
            console.warn('DEBUG => [Vuex->ACTION->loadDynamicConfigurationDataFromStorage] Config data loaded from storage is not an array, resetting to empty');
            data = [];
          }
        }
        commit(types.SET_CONFIGURATION, data);
        if (data.length === 0) {
          console.warn('DEBUG => [Vuex->ACTION->loadDynamicConfigurationDataFromStorage] No configuration data found in storage');
          commit(types.SET_CONFIGURATION_DATA_LOADED, false);
          return false;
        }
        commit(types.SET_CONFIGURATION_DATA_LOADED, true);
        console.log('DEBUG => [Vuex->ACTION->loadDynamicConfigurationDataFromStorage] Configuration loaded from storage:', data);
        return true;
      } catch (error) {
        console.error('DEBUG => [Vuex->ACTION->loadDynamicConfigurationDataFromStorage] Error loading configuration from storage:', error);
        commit(types.SET_CONFIGURATION, []);
        commit(types.SET_CONFIGURATION_DATA_LOADED, false);
        return false;
      }
    },

    // Fetch fresh config from API and update state + storage
    async getConfigurationValues({ commit }) {
      const key = 'configuration';
      try {
        const response = await api.lookupsZeus(key, {
          headers: { 'Content-Type': 'application/json' }
        });
        console.log('[Vuex] Configuration fetched from API:', response.data);
        commit(types.SET_CONFIGURATION, response.data);
        commit(types.SET_CONFIGURATION_DATA_LOADED, true);
        return response.data;
      } catch (error) {
        commit(types.SET_CONFIGURATION_DATA_LOADED, false);
        console.error('[Vuex] Failed to fetch configuration from API:', error);
        throw error;
      }
    },

    // Preload config: first from storage, then refresh from API
    async preloadConfigurationData({ dispatch }) {
      try {
        await dispatch('loadDynamicConfigurationDataFromStorage');
        await dispatch('getConfigurationValues');
        console.log('[Vuex] Configuration preload complete');
      } catch (error) {
        console.error('[Vuex] Configuration preload failed:', error);
      }
    }
  }
};
